"use client";

import { CustomerType } from "@/types/customer.type";
import { createContext, ReactNode } from "react";

export const Context = createContext<{ customer: CustomerType | null } | null>(
  null,
);

export default function SessionProvider({
  children,
  session,
}: {
  children: ReactNode;
  session: CustomerType | null;
}) {
  return (
    <Context.Provider value={{ customer: session }}>
      {children}
    </Context.Provider>
  );
}
